import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { parseUrlPathInSegments } from './url-path-parser';
import { CommunicationService } from '../../services/communication/communication.service';
import { first } from 'rxjs/operators'

/**
 * This guard is used to fetch the queue boards before loading main componentglobal.fetch = require('node-fetch');
 * 
 * It will generate the router link and bind it to sidebar
 */
@Injectable()
export class DynamicPathGuard implements CanActivate {
  constructor(private router: Router,
    private communicationService: CommunicationService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const segments = parseUrlPathInSegments(state.url);
    const lastPath = segments.pop();
    return new Promise(resolve => {
      this.communicationService.getBoard().then(res=>{
        if(res){
          this.communicationService.getBoards.pipe(first()).subscribe(routeList=>{
            if (routeList.find(x => x.routeName === lastPath)) {
              setTimeout(() => {
                this.router.navigateByUrl(state.url);
              }, 0);
            } else {
              this.router.navigateByUrl('/404');
            }
          })
        }else
          this.router.navigate(['']);
      });
    })
  }
}